import { axiosRequest } from '../api';
import { API_PATH } from '../../constants';

export const GeneralService = {
  uploadMultimedia(data){ return axiosRequest('POST', API_PATH.GENERAL.UPLOAD_MULTIMEDIA, data) },
}